<template>
    <Dropdown :title="dropdownTitle" ref="Dropdown">
        <div class="from-to-dates">
            <FormGroup :label="translate('labels.from')" class="mb-0">
                <Input
                    v-model="fromValue"
                    type="number"
                />
            </FormGroup>
            <FormGroup :label="translate('labels.to')" class="mb-0">
                <Input
                    v-model="toValue"
                    type="number"
                />
            </FormGroup>
        </div>
    </Dropdown>
</template>
<script>
import Dropdown from "./DropdownComponent.vue";
import Input from "../../../new/form/Input.vue";
import FormGroup from "../../../new/form/group/FormGroup.vue";

export default  {
    name: "FromToNumberComponent",
    props: ['title', 'from', 'to'],
    emits: ['update:from', 'update:to'],
    computed: {
        fromValue: {
            get() {
                return this.from
            },
            set(newValue) {
                this.setValue('from', newValue)
            }
        },
        toValue: {
            get() {
                return this.to
            },
            set(newValue) {
                this.setValue('to', newValue)
            }
        },
        dropdownTitle() {
            let title = this.title;

            if (this.from || this.to) {
                title += `:`
            }

            if (this.from) {
                title += ` ${translate('labels.from')} ${this.from}`
            }

            if (this.to) {
                title += ` ${translate('labels.to')} ${this.to}`
            }

            return title;
        }
    },
    methods: {
        setValue(key, value) {
            this.$emit(`update:${key}`, value)
        }
    },
    components: {
        Dropdown,
        Input,
        FormGroup
    }
}
</script>

<style scoped>
.from-to-dates{
    padding: 13px 10px;
    display: flex;
    column-gap: 10px;
}
</style>